import jsCookie from 'js-cookie';

export default () => {
  jsCookie.set('USER_LAST_ACTIVITY', Date.now());
  jsCookie.set('AUTO_LOGOUT_TIME', Date.now() + 1000 * 60 * 15);
  jsCookie.set('NOTIFY_USER_ABOUT_SESSION_END_TIME', Date.now() + 1000 * 60 * 13);
};
